import './App.css';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import MainLayout from "./components/MainLayout";
import Tests from "./components/Tests";
import Statistics from "./components/Statistics";
import UserSettings from './components/UserSettings';
import Register from "./components/Register";
import ChooseExam from './components/ChooseExam';
import ReadingComponent from './components/ReadingComponent';
import MathComponent from './components/MathComponent';
import CVESDIAComponents from './components/CVESD-IAComponents';
import ProtectedRoute from "./components/ProtectedRoute";
import PasswordResetRequest from './components/PasswordResetRequest';
import ResetPassword from './components/ResetPassword';
import UsersAll from './components/pages/UsersAll';
import AnyTestComponent from './components/AnyTestComponent';
import Schedule from './components/pages/Schedule';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SystemMessageProvider } from './providers/SystemMessageContext';
import muiTheme from './theme';
import ExamCatalog from './components/pages/ExamCatalog';
import ExamComponentCatalog from './components/pages/ExamComponentCatalog';
import ExamLaunchPad from './components/pages/ExamLaunchpad';
import ReservationPipeline from './components/pages/ReservationPipeline';
import ExamStudio from './components/pages/ExamStudio';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("access_token"));

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem("access_token"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <SystemMessageProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login onLogin={(token) => setToken(token)} />} />
            <Route path="/register" element={<Register onRegisterSuccess={() => setToken(token)} />} />
            <Route path="password-reset-request" element={<PasswordResetRequest />} />
            <Route path="reset-password" element={<ResetPassword />} />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<MainLayout />}>
                <Route index element={<ExamCatalog />} />
                <Route path="exam-catalog" element={<ExamCatalog />} />
                <Route path="exam-component-catalog/:exam_base_id" element={<ExamComponentCatalog />} />
                <Route path="exam-launchpad/:exam_component_base_id" element={<ExamLaunchPad />} />
                <Route path="reservation-pipeline/:time_slot_id" element={<ReservationPipeline />} />
                <Route path="chooseExam" element={<ChooseExam />} />
                <Route path="statistics" element={<Statistics />} />
                <Route path="user-settings" element={<UserSettings />} />
                <Route path="cvesd-iaComponents/:examId" element={<CVESDIAComponents />} />
                <Route path="users-all" element={<UsersAll />} /> 
                <Route path="schedule" element={<Schedule />} />
                <Route path="exam-studio" element={<ExamStudio />} />
              </Route>
              <Route path="timed-exam-component/:exam_component_id/:exam_component_base_id" element={<AnyTestComponent />}/>
              <Route path="tests" element={<Tests />} />
              <Route path="readingComponent" element={<ReadingComponent />} />
              <Route path="mathComponent" element={<MathComponent />} />
            </Route>

            {/* Redirect all unknown paths */}
            <Route path="*" element={<Navigate to={token ? "/" : "/login"} replace />} />
          </Routes>
        </Router>
      </SystemMessageProvider>
    </ThemeProvider>
  );
};

export default App;
